import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

const app = createApp(App)
app.use(router)

// 全局禁止右键菜单
app.directive('no-context', {
  mounted(el) {
    el.addEventListener('contextmenu', (e) => {
      e.preventDefault()
      return false
    })
  }
})

app.mount('#app')